function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'athletic-grey': 'rgb(191, 192, 194)','sand': 'rgb(216, 195, 165)','oat': 'rgb(230, 216, 184)','sky-blue': 'rgb(135, 206, 235)','slate-grey': 'rgb(112, 128, 144)','dark-grey': 'rgb(74, 74, 74)','navy': 'rgb(11, 31, 59)','evergreen': 'rgb(5, 71, 42)','bright-blue': 'rgb(0, 123, 255)','peppermint': 'rgb(152, 255, 204)','stone-blue': 'rgb(108, 127, 141)','navy-blue': 'rgb(11, 31, 59)','light-heather': 'rgb(191, 192, 194)','khaki': 'rgb(93, 101, 50)','natural-french-navy': 'rgb(11, 31, 59)','natural-sage-green': 'rgb(5, 71, 42)','mustard': 'rgb(255, 219, 88)','mauve': 'rgb(224, 176, 255)','solent-sage-stripes': 'rgb(0, 124, 161)','taupe-stripes': 'rgb(146, 124, 102)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
